import { makeStyles } from "@material-ui/styles";

export default makeStyles(
    {
        container: {
            display: "flex",
            justifyContent: "flex-start",
            marginTop: "10px",
        },
        
        containerTitulo: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
        },

        containerTituloPrincipal: {
            display: "flex",
            alignItems: 'center',
            justifyContent: 'space-between',
            marginTop: "5px",
        },
        
        titulo: {
            fontWeight: "400",
            fontSize: "20px",
            lineHeight: "43px",
            color: "#02599E",
        },

        ayuda: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: "7px",
            fontWeight: "bold",
            fontSize: "10px",
            lineHeight: "9px",
            width: "16px",
            height: "16px",
            borderRadius: "8px",
            background: "#727A94",
            color: "white",
        },

        codPrestador: {
            width: "230px",
            marginRight: "20px",
        },

        email: {
            width: "375px",
            marginRight: "20px",
        },

        telefono: {
            width: "375px",
        },

        dropDownIcon: {
            color: "#BDBDBD",
            margin: "5px",
        },
        textoObligatorios: {
            
            fontFamily: 'Roboto',
            fontSize: '10px',
            lineHeight: '15px',
            color: '#7E7E7E',
            marginTop: '0px',
        },
    },
    { index: 1 }
);
